import { InputLabel, InputLabelProps } from "@mantine/core";
import { useTheme } from "@contexts/ThemeContext";

/**
 * JarvisInputLabel - A themed InputLabel component that automatically applies
 * the current theme text color.
 *
 * Usage: Use this instead of Mantine's InputLabel to get automatic theming.
 */
export const JarvisInputLabel = (props: InputLabelProps) => {
  const { colors: themeColors } = useTheme();

  return (
    <InputLabel
      {...props}
      c={themeColors.text}
    />
  );
};

export default JarvisInputLabel;
